import AllotmentCards from "@/features/landing/components/allotment-cards";
import CourseCards from "@/features/landing/components/course-cards";
import { LandingCategoryGrid } from "@/features/landing/components/landing-category-grid";
import ArticleGroupProductsWrapper from "@/features/landing/components/product-cards/article-group-products-wrapper";
import RegularProductsWrapper from "@/features/landing/components/product-cards/regular-products-wrapper";
import SessionCards from "@/features/landing/components/session-cards";
import { HeroMarkdownSection } from "@/features/shared/components/hero-markdown-section-client";
import { HeroMarkdownSkeleton } from "@/features/shared/components/hero-markdown-skeleton";
import { useLng } from "@/hooks/use-lng";
import { formatAppTitle } from "@/lib/app-document-title";
import { useTranslation } from "@/lib/i18n/client";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/_app/")({
  head: () => ({
    meta: [{ title: formatAppTitle() }]
  }),
  component: HomePage
});

function HomePage() {
  const lng = useLng();
  const { t } = useTranslation(lng, "translation");
  return (
    <main className="h-full w-full">
      <Suspense fallback={<HeroMarkdownSkeleton />}>
        <HeroMarkdownSection lng={lng} section="landing" />
      </Suspense>
      <div className="container mx-auto space-y-10 p-0 py-8">
        <div className="space-y-3 px-4">
          <h2 className="text-2xl font-semibold">{t("categories")}</h2>
          <LandingCategoryGrid />
        </div>
        <div className="mb-4 space-y-1 px-4">
          <h2 className="text-2xl font-semibold">{t("our-activities")}</h2>
          <p className="text-muted-foreground">{t("our-activities-description")}</p>
        </div>
        <CourseCards />
        <SessionCards />
        <AllotmentCards />
        <RegularProductsWrapper />
        <ArticleGroupProductsWrapper />
      </div>
    </main>
  );
}
